import BaseService from "@/services/BaseService";

export default class ShareModelCarrierService extends BaseService {
  constructor() {
    super("insurance_pricing/share_models");
  }

  findAllByShareModelId(shareModelId, data) {
    return this.http.get(`${this._serviceName}/${shareModelId}/carriers`, {
      params: data,
    });
  }

  save(shareModelId, data) {
    return this.http.post(
      `${this._serviceName}/${shareModelId}/carriers`,
      data
    );
  }

  delete(shareModelId, id) {
    return this.http.delete(
      `${this._serviceName}/${shareModelId}/carriers/${id}`
    );
  }

  update(shareModelId, id, data) {
    return this.http.put(`${this._serviceName}/${shareModelId}/carriers/${id}`, data)
  }

  updateCopay(shareModelId, id, data) {
    return this.http.put(`${this._serviceName}/${shareModelId}/carriers/${id}/copay`, data)
  }
}
